<template>
  <div class="login-container">
    <Loading v-if="isLoading" />
    <Alert v-if="$store.state.alert" />
    <div class="login-content">
      <div class="login-header">
        <div class="welcome-text">Reset Password</div>
        <div class="sub-welcome-text">
          Silahkan masukkan password baru untuk akun anda
        </div>
      </div>
      <div class="login-form-container">
        <div class="login-form-wrapper">
          <div class="register-input-field">
            <div class="register-input-label">Enter New Password</div>
            <input
              type="password"
              class="register-input"
              placeholder="********"
              v-model="password"
            />
          </div>
          <div class="register-input-field">
            <div class="register-input-label">Confirm Password</div>
            <input
              type="password"
              class="register-input"
              placeholder="********"
              v-model="confPassword"
            />
          </div>
          <div class="login-btn" @click="resetPassword">Reset Password</div>
          <div class="email-sipm">
            <p>
              Jika mengalami kendala, mohon dapat menghubungi email
              <a href="#">SIPM_Member_Team@sinarmasmining.com</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { api } from '../../services/config'
import axios from 'axios'
export default {
  components: {
    Loading: () => import('@/components/utils/Loading'),
    Alert: () => import('@/components/Modal/Alert'),
  },
  data() {
    return {
      password: '',
      confPassword: '',
      token: '',
      isLoading: false,
    }
  },
  created() {
    this.token = this.$router.currentRoute.query.token
    if (!this.token) {
      this.$router.push({ path: '/' })
    }
  },
  methods: {
    async resetPassword() {
      try {
        if (this.password.length < 8 && this.confPassword != '') {
          alert('Password tidak boleh kurang dari 8 karakter')
          return false
        }

        if (this.password == this.confPassword && this.password != '') {
          this.isLoading = true
          const { data } = await axios({
            method: 'POST',
            url: `${api}/api/v1/auth/reset`,
            data: {
              token: this.token,
              password: this.password,
              confirmation: this.confPassword,
            },
          })

          if (data && data.status == 'success') {
            this.isLoading = false
            alert('Selamat password anda telah terganti, silahkan login')
            this.$router.push({ path: '/' })
          }
        } else {
          if (this.password == '' || this.confPassword == '') {
            alert('Password dan konfirmasi password tidak boleh kosong')
          } else {
            alert('Password dan konfirmasi password tidak sama!')
          }
        }
      } catch (error) {
        console.log('error: ', error)
        this.isLoading = false
        if (this.$get(error, 'response.data.message')) {
          alert(this.$get(error, 'response.data.message'))
        } else {
          alert(error)
        }
      }
    },
  },
}
</script>
